var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuluLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 100,
    height: 23,
    viewBox: "0 0 100 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.2861 0C81.8417 0 81.4815 0.360747 81.4815 0.805751V12.9542C81.4815 16.134 82.3194 18.6679 83.9615 20.4108C85.6098 22.16 87.962 23 90.7554 23C93.5491 23 95.8948 22.1599 97.5359 20.4093C99.1704 18.6659 100 16.1321 100 12.9542V0.805751C100 0.360747 99.6398 0 99.1954 0H97.0781C96.6337 0 96.2735 0.360747 96.2735 0.805751V12.8633C96.2735 15.2703 95.723 16.8769 94.8282 17.8773C93.948 18.8617 92.6169 19.389 90.7554 19.389C88.9104 19.389 87.5867 18.8626 86.7093 17.8783C85.8172 16.8776 85.2669 15.2703 85.2669 12.8633V0.805751C85.2669 0.360747 84.9067 0 84.4622 0H82.2861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.5556 22.1943C55.5556 22.6392 55.9124 23 56.3524 23H71.4254C71.8654 23 72.2222 22.6392 72.2222 22.1943V20.2387C72.2222 19.7938 71.8654 19.433 71.4254 19.433H59.543V0.805751C59.543 0.360747 59.1861 0 58.7459 0H56.3524C55.9124 0 55.5556 0.360747 55.5556 0.805751V22.1943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.5824 0C28.138 0 27.7778 0.360747 27.7778 0.805751V12.9542C27.7778 16.134 28.6157 18.6679 30.2578 20.4108C31.9061 22.16 34.2583 23 37.0517 23C39.8454 23 42.1911 22.1599 43.8322 20.4093C45.4667 18.6659 46.2963 16.1321 46.2963 12.9542V0.805751C46.2963 0.360747 45.9361 0 45.4917 0H43.3744C42.93 0 42.5698 0.360747 42.5698 0.805751V12.8633C42.5698 15.2703 42.0193 16.8769 41.1244 17.8773C40.2443 18.8617 38.9131 19.389 37.0517 19.389C35.2067 19.389 33.883 18.8626 33.0056 17.8783C32.1135 16.8776 31.5631 15.2703 31.5631 12.8633V0.805751C31.5631 0.360747 31.203 0 30.7585 0H28.5824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.34928 22.1943C7.34928 22.6392 7.70952 23 8.15387 23H10.3646C10.809 23 11.1692 22.6392 11.1692 22.1943V3.56702H17.7139C18.1583 3.56702 18.5185 3.20627 18.5185 2.76127V0.805751C18.5185 0.360747 18.1583 0 17.7139 0H0.8046C0.360231 0 0 0.360747 0 0.805751V2.76127C0 3.20627 0.360231 3.56702 0.8046 3.56702H7.34928V22.1943Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuluLogoBlack);
export default __webpack_public_path__ + "static/media/tuluLogoBlack.3242d4f51da58c34b8892da9e6e894c2.svg";
export { ForwardRef as ReactComponent };